import { useIntl } from 'react-intl';
import { Divider, Form } from 'antd';

import TabContentWrapper from '@/components/_common/TabContentWrapper';
import PurchasesReleaseForm from '@/components/Movements/Purchases/PurchasesReleaseForm';
import {
  PurchaseCreateFormValues,
  PurchaseCreateRequest,
} from '@/core/domain/purchase/Purchase.types';

import { usePurchaseCreate } from '@/core/domain/purchase/Purchase.hooks';
import { useHistory } from 'react-router-dom';
import { SaveButton } from '@/components/_common';
import Authorities from '@/types/Authority';
import SpaceForButton from '@/components/_common/SpaceForButtons';
import ButtonBack from '@/components/_common/ButtonBack';
import { hasPermissions } from '@/utils/functions/hasPermissions';

function PurchasesReleasesCreatePage() {
  const intl = useIntl();
  const history = useHistory();

  const [form] = Form.useForm<PurchaseCreateFormValues>();
  const createMutation = usePurchaseCreate();

  const handleCreatePurchase = async () => {
    try {
      const { supplier, ...values } = await form.validateFields();

      const obj: PurchaseCreateRequest = {
        ...values,
        deliveryPrevisionDate: values.deliveryPrevisionDate?.format(),
        departureDate: values?.departureDate?.toISOString(),
        issueDate: values.issueDate.toISOString(),
        releaseDate: values?.releaseDate?.toISOString(),
        supplierDTO: {
          id: supplier.id,
        },
      };

      const result = await createMutation.mutateAsync(obj);
      history.push(`/app/movements/purchases/purchasesReleases/${result.id}`);
    } catch {}
  };

  return (
    <TabContentWrapper
      title="purchases.create.general"
      extra={
        <SaveButton
          block
          onClick={handleCreatePurchase}
          loading={createMutation.isLoading}
          disabled={!hasPermissions([Authorities.MOVIMENTATION_PURCHASE_ADD])}
        >
          {intl.formatMessage({ id: 'commons.entity.save' })}
        </SaveButton>
      }
    >
      <PurchasesReleaseForm form={form} />

      <Divider />

      <SpaceForButton>
        <ButtonBack path="/app/movements/purchases/purchasesReleases" />
      </SpaceForButton>
    </TabContentWrapper>
  );
}

export default PurchasesReleasesCreatePage;
